import React from 'react'
import PropTypes from 'prop-types'

const DropdownMenu = props => {
  const { children, active } = props
  return (
    <div className={active ? 'dropdown-menu active' : 'dropdown-menu'}>
      <div className="dropdown-menu__inner">
        { children }
      </div>
    </div>
  )
}

DropdownMenu.propTypes = {
  children: PropTypes.array.isRequired,
  active: PropTypes.bool,
}

export default DropdownMenu



// WEBPACK FOOTER //
// /opt/build/repo/src/components/DropdownMenu.js